import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';

export interface PpmSuperactivityCreateModel {
  nam: string;
  shc: string;
  dsc: string;
  psc: string;
  pmd: string;
  pnt: string;
  rvt: string;
}

interface Props {
  open: boolean;
  saving: boolean;

  onClose: () => void;
  onSave: (model: PpmSuperactivityCreateModel) => void;
}

interface State extends PpmSuperactivityCreateModel { }

const initialState: State = {
  nam: '',
  shc: '',
  dsc: '',
  psc: 'FONCTIONNEMENT',
  pmd: '',
  pnt: '',
  rvt: '01',
};

export default class PpmSuperactivityCreateDialog extends React.Component<
  Props,
  State
> {
  state: State = { ...initialState };

  componentDidUpdate(prevProps: Props) {
    if (this.props.open && !prevProps.open) {
      this.setState({ ...initialState });
    }
  }

  change =
    (key: keyof State) =>
      (event: any) => {
        this.setState({
          [key]: event.target.value,
        } as Pick<State, keyof State>);
      };

  canSave = () => {
    return (
      this.state.nam.trim().length > 0 &&
      this.state.shc.trim().length > 0
    );
  };

  save = () => {
    if (!this.canSave()) {
      return;
    }

    this.props.onSave({
      ...this.state,
      nam: this.state.nam.trim(),
      shc: this.state.shc.trim().toUpperCase(),
      dsc: this.state.dsc.trim(),
    });
  };

  render() {
    const { open, saving, onClose } = this.props;

    return (
      <Dialog
        open={open}
        onClose={saving ? undefined : onClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Create Superactivity
        </DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2}>
            <TextField
              label="Code"
              value={this.state.shc}
              onChange={this.change('shc')}
              required
              fullWidth
              disabled={saving}
              inputProps={{
                style: { textTransform: 'uppercase' },
              }}
            />

            <TextField
              label="Superactivity Name"
              value={this.state.nam}
              onChange={this.change('nam')}
              required
              fullWidth
              disabled={saving}
            />

            <TextField
              label="Description"
              value={this.state.dsc}
              onChange={this.change('dsc')}
              multiline
              minRows={2}
              fullWidth
              disabled={saving}
            />

            <FormControl fullWidth>
              <InputLabel>PPM Section</InputLabel>

              <Select
                label="PPM Section"
                value={this.state.psc}
                onChange={this.change('psc')}
                disabled={saving}
              >
                <MenuItem value="FONCTIONNEMENT">
                  Fonctionnement
                </MenuItem>

                <MenuItem value="INVESTISSEMENT">
                  Investissement
                </MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Procurement Method"
              value={this.state.pmd}
              onChange={this.change('pmd')}
              fullWidth
              disabled={saving}
            />

            <TextField
              label="Prestation Nature"
              value={this.state.pnt}
              onChange={this.change('pnt')}
              fullWidth
              disabled={saving}
            />

            <TextField
              label="Review Type"
              value={this.state.rvt}
              onChange={this.change('rvt')}
              fullWidth
              disabled={saving}
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={this.save}
            disabled={saving || !this.canSave()}
          >
            {saving ? 'Creating...' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}